module.exports = __webpack_public_path__ + "47f020697bac415d821dd3a2b06be53b.svg";